/* global window */
import { supportLocalStorage } from './localStorage';
const DAYTOMILLISECOND = 86400000;

const resetOldSafetyTipsTimestamp = () => {
    if (supportLocalStorage()) {
        if (window.localStorage.getItem('seenFirstTimeUserTips') === 'true') {
            window.localStorage.removeItem('seenFirstTimeUserTips');
        }
    }
};

const shouldShowTips = () => {
    if (supportLocalStorage()) {
        resetOldSafetyTipsTimestamp();
        if (window.localStorage.getItem('seenFirstTimeUserTips')) {
            if (window.localStorage.getItem('safetyTipsValidity')) {
                const safetyTipsTimestamp = parseInt(window.localStorage.getItem('seenFirstTimeUserTips'), 10);
                const safetyTipsValidTimestamp = parseInt(window.localStorage.getItem('safetyTipsValidity'), 10);

                return Date.now() - safetyTipsTimestamp > safetyTipsValidTimestamp;
            }
            return false;
        }
        return true;
    }
    return false;
};

const setSafetyTipsTimestamp = () => {
    if (supportLocalStorage()) {
        window.localStorage.setItem('seenFirstTimeUserTips', Date.now());
    }
};

const setSafetyTipsData = data => {
    if (supportLocalStorage()) {
        window.localStorage.setItem('safety_tips_data', JSON.stringify(data));
    }
};

const setSafetyTipsValidity = timeLimit => {
    if (supportLocalStorage()) {
        window.localStorage.setItem('safetyTipsValidity', timeLimit * DAYTOMILLISECOND);
    }
};

const hasSafetyTipsData = () => {
    if (supportLocalStorage()) {
        return !!window.localStorage.getItem('safety_tips_data');
    }
    return false;
};

const readSafetyTipsData = () => {
    if (supportLocalStorage()) {
        const safetyTips = window.localStorage.getItem('safety_tips_data');

        return JSON.parse(safetyTips);
    }
    return [];
};

export {
    shouldShowTips,
    setSafetyTipsTimestamp,
    setSafetyTipsValidity,
    resetOldSafetyTipsTimestamp,
    setSafetyTipsData,
    readSafetyTipsData,
    hasSafetyTipsData
};
